import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import LookupSelect from "@/components/forms/LookupSelect";
import { useLookups } from "@/contexts/LookupsContext";

export default function CandidateFilters({ filters, onChange, onReset }) {
  const { t } = useTranslation();
  const lookups = useLookups();
  if (!lookups) return null;

  const set = (field, value) => onChange({ ...filters, [field]: value });

  return (
    <div className="bg-white rounded-2xl border border-black/5 shadow-[0_4px_24px_rgba(0,0,0,0.03)] p-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-testid="candidate-filters-panel">
      <LookupSelect options={lookups.countries} value={filters.country_wanted} onChange={(v) => set("country_wanted", v)}
                    labelPrefix="lookups.countries" placeholder={t("search.filterCountry")} testId="candidate-filter-country-select" includeAll />
      <LookupSelect options={lookups.regions} value={filters.region_wanted} onChange={(v) => set("region_wanted", v)}
                    labelPrefix="lookups.regions" placeholder={t("search.filterRegion")} testId="candidate-filter-region-select" includeAll />
      <LookupSelect options={lookups.skills} value={filters.skill} onChange={(v) => set("skill", v)}
                    labelPrefix="lookups.skills" placeholder={t("candidateProfile.skillsSection")} testId="candidate-filter-skill-select" />
      <LookupSelect options={lookups.housing_options} value={filters.housing_wanted} onChange={(v) => set("housing_wanted", v)}
                    labelPrefix="lookups.housingOptions" placeholder={t("search.filterHousing")} testId="candidate-filter-housing-select" />
      <LookupSelect options={lookups.languages} value={filters.language} onChange={(v) => set("language", v)}
                    labelPrefix="lookups.languages" placeholder={t("search.filterLanguage")} testId="candidate-filter-language-select" />
      <LookupSelect options={lookups.permits} value={filters.permit} onChange={(v) => set("permit", v)}
                    labelPrefix="lookups.permits" placeholder={t("search.filterPermit")} testId="candidate-filter-permit-select" />
      <LookupSelect options={lookups.worker_statuses} value={filters.worker_status} onChange={(v) => set("worker_status", v)}
                    labelPrefix="lookups.workerStatuses" placeholder={t("search.filterWorkerStatus")} testId="candidate-filter-worker-status-select" includeAll />
      <label className="flex items-center gap-2 cursor-pointer h-12 px-1">
        <Checkbox checked={!!filters.tesa_ready} onCheckedChange={(v) => set("tesa_ready", v ? true : undefined)} data-testid="candidate-filter-tesa-ready-checkbox" />
        <span className="text-sm font-medium">{t("search.filterTesaReady")}</span>
      </label>
      <Button variant="outline" onClick={onReset} className="h-12 rounded-xl" data-testid="candidate-filter-reset-button">
        {t("common.resetFilters")}
      </Button>
    </div>
  );
}
